/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-05T19:13:41.294
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentConsumeMaterialCompany,
	listRentConsumeMaterialCompanyInit,
	listRentConsumeMaterialCompanyByAuthorizations,
	deleteRentConsumeMaterialCompany
} from '@api/rentmanage/RentConsumeMaterialCompany';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentConsumeMaterialCompany({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentConsumeMaterialCompany(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentConsumeMaterialCompanyByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentConsumeMaterialCompanyByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentConsumeMaterialCompanyInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentConsumeMaterialCompanyInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentConsumeMaterialCompany({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentConsumeMaterialCompany({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
